import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../../../../components/ui/dialog'
import { Button } from '../../../../../components/ui/button'
import { Label } from '../../../../../components/ui/label';
import { Input } from '../../../../../components/ui/input';

const YcrSubModel = (props) => {
    const { show, onHide, data } = props;
    const [formData, setFormData] = useState({
        name: ""
    })

    useEffect(() => {
        setFormData(() => ({
            ...formData,
            name: data?.Name
        }))
    }, [data])
    console.log(data)

    const onSave = () => { 
        console.log(formData)
    }
    const onChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        })
    }

    return (
        <div>
            <Dialog open={show} onOpenChange={onHide}>
                <DialogContent className="sm:max-w-[60%] gap-0 p-0">
                    <DialogHeader className="p-5 border-b border-borderV1">
                        <DialogTitle className="text-start">Edit Model</DialogTitle>
                    </DialogHeader>
                    <div className="dialog-body p-5">

                        <div className="grid grid-cols-1  gap-5">
                            <div className='space-y-1'>
                                <Label htmlFor="name" className="text-sm text-textV2 font-500">Name</Label>
                                <Input type="text" value={formData?.name} name="name" placeholder="Enter Name.." id="name" className="input-box" onChange={onChange} />
                            </div>

                        </div>

                    </div>
                    <DialogFooter className={"!justify-center !gap-2 p-5"}>
                        <Button type="submit" size="sm" className="min-w-[100px]" onClick={onSave}>Save</Button>
                        <Button type="submit" className="min-w-[100px]" size="sm" variant={"outline"} onClick={onHide}>Cancel</Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default YcrSubModel